export const ADRESS_TYPES = {
	INVOICE: 1,
	DELIVERY: 2,
}

export const ORDER_LINE_TYPES = {
	Article: 1,
	Payment: 2,
	Message: 3,
	Collection: 4,
	Discount: 5,
	Menu: 6,
	Subscription: 7,
	Ticket: 8,
	Activity: 9,
	Voucher: 10,
	VoucherDetail: 11,
	ObjectGroup: 12,
	Account: 13,
	ReceiptMessage: 14,
	CashFlow: 15,
	Object: 16,
}

export const TICKET_TYPES = {
	Morning: 1,
	Afternoon: 2,
	Evening: 3,
	Night: 4,
	WholeDay: 5,
}

export const PAYMENT_TYPES = {
	ApplePay: "applePay",
	GooglePay: "googlePay",
	Invoice: "invoice",
	AmazonPay: "amazonPay",
	InstantBankTransfer: "instantBankTransfer",
	CreditCard: "creditCard",
	PayPal: "payPal",
	Thermencard: "thermencard",
	EC_Terminal: "ec-terminal",
	EmployeePoints: "employeePoints",
}

export const IframeMessages = {
	getShoppingCart: "getShoppingCart",
	getRelationSessionToken: "getRelationSessionToken",
	setRelationSessionToken: "setRelationSessionToken",
	deleteRelationSessionToken: "deleteRelationSessionToken",
	returnRelationSessionToken: "returnRelationSessionToken",
	returnShoppingCart: "returnShoppingCart",
	setAmazonButtonData: "setAmazonButtonData",
	initinateAmazonPay: "initinateAmazonPay",
	openUrl: "openUrl",
	updateShoppingCartItem: "updateShoppingCartItem",
	deleteShoppingCartItem: "deleteShoppingCartItem",
	addShoppingCartItem: "addShoppingCartItem",
	deleteShoppingCart: "deleteShoppingCart",
	tackTradeDesk: "trackTradeDesk",
	setShoppingCart: "setShoppingCart",
	returnShoppingCartTime: "returnShoppingCartTime",
	getShoppingCartTime: "getShoppingCartTime",
	googleEvent: "googleEvent",
}

export const LinkTypes = {
	agb: "agb",
	privacy: "privacy",
	impressum: "impressum",
	payments: "payments",
	delivery: "delivery",
	deliveryFee: "deliveryFee",
	withdrawal: "withdrawal",
	openingHours: "openingHours",
	orderProcess: "orderProcess",
	specialOpeningHours: "specialOpeningHours",
}

export const languageMap = {
	de: "de-DE",
	en: "en-GB",
	fr: "fr-FR",
	nl: "nl-NL",
}
export const currencyMap = {
	"de-DE": "EUR",
	"en-GB": "EUR",
	"fr-FR": "EUR",
	"nl-NL": "EUR",
}

export const OrderErrors = {
	/**
	 * When the wanted capacity is higher than the count of visitors with lounger capability
	 */
	noMoreCapacityThanGuests: "noMoreCapacityThanGuests",
	/**
	 * If an adult has a lounger all adults need a sitplace
	 */
	allAdultNeedsAnLounger: "allAdultNeedsAnLounger",
	mapAllLoungerNeedsSelection: "mapAllLoungerNeedsSelection",
	noSelectedPersons: "noSelectedPersons",
	noSelectedDate: "noSelectedDate",
	noSelectedTicket: "noSelectedTicket",
	noSelectedTimeslot: "noSelectedTimeslot",
	deliveryCountryNotValid: "deliveryCountryNotValid",
}

export const SCANCODE_TYPES = {
	ARTICLE: 1,
	TICKET: 5,
	VOUCHER: 10,
	PRICEACTION: 12,
}

export const KEYBOARD_KEY_SET = {
	Tab: "Tab",
	Escape: "Escape",
	ArrowUp: "ArrowUp",
	ArrowDown: "ArrowDown",
	ArrowLeft: "ArrowLeft",
	ArrowRight: "ArrowRight",
	ShiftAndTab: "ShiftAndTab",
	Select: "Enter",
	Plus: "Plus",
	Minus: "Minus",
}

/*
 * Map key symbols (like "+", "-") into unique actions.
 * This way, we can identify the symbol and pass the action
 * as key to an to a key-pair object.
 */
export const KEYBOARD_KEYS = {
	Tab: KEYBOARD_KEY_SET.Tab,
	Escape: KEYBOARD_KEY_SET.Escape,
	ArrowUp: KEYBOARD_KEY_SET.ArrowUp,
	ArrowDown: KEYBOARD_KEY_SET.ArrowDown,
	ArrowLeft: KEYBOARD_KEY_SET.ArrowLeft,
	ArrowRight: KEYBOARD_KEY_SET.ArrowRight,
	ShiftAndTab: KEYBOARD_KEY_SET.ShiftAndTab,
	"+": KEYBOARD_KEY_SET.Plus,
	"=": KEYBOARD_KEY_SET.Plus, // "=" equals "+" in american keyboards
	"-": KEYBOARD_KEY_SET.Minus,
	_: KEYBOARD_KEY_SET.Minus, // "_" equals "-" in american keyboards
	Enter: KEYBOARD_KEY_SET.Select,
	" ": KEYBOARD_KEY_SET.Select,
}
